// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import RichMedia from '../RichMedia';
import VideoPlayer from './VideoPlayer';

const VideoMedia = ({
    element,
    width,
    gridSize,
    isPresentational,
    attachment,
    dispatchUploadFile,
    isHovered,
    canDrop,
    dispatchRichMediaEmbedding,
    dispatchAcceptElementAttachmentUndo,
    dispatchUpdateElement,
    isReplaceModeHovered,
}) => (
    <RichMedia
        element={element}
        width={width}
        gridSize={gridSize}
        isReplaceModeHovered={isReplaceModeHovered}
        ContentComponent={VideoPlayer}
        isPresentational={isPresentational}
        attachment={attachment}
        dispatchUploadFile={dispatchUploadFile}
        isHovered={isHovered}
        canDrop={canDrop}
        dispatchRichMediaEmbedding={dispatchRichMediaEmbedding}
        dispatchAcceptElementAttachmentUndo={dispatchAcceptElementAttachmentUndo}
        dispatchUpdateElement={dispatchUpdateElement}
    />
);

VideoMedia.propTypes = {
    element: PropTypes.object.isRequired,
    width: PropTypes.number,
    gridSize: PropTypes.number,
    isPresentational: PropTypes.bool,
    attachment: PropTypes.object,
    dispatchUploadFile: PropTypes.func,
    isHovered: PropTypes.bool,
    canDrop: PropTypes.bool,
    dispatchRichMediaEmbedding: PropTypes.func,
    dispatchAcceptElementAttachmentUndo: PropTypes.func,
    dispatchUpdateElement: PropTypes.func,
    isReplaceModeHovered: PropTypes.bool,
};

export default VideoMedia;
